import { CheckboxField } from '@monorepo/shared/componentsV2/fields/CheckboxField';
import { getFieldNameWithPrefix } from '@monorepo/shared/componentsV2/fields/fieldUtils';
import React from 'react';
import { ModalFieldWrapper } from '../styled';

type AlphabetizeOptionsProps = { prefix?: string };

export function AlphabetizeOptions({ prefix }: AlphabetizeOptionsProps) {
  return (
    <ModalFieldWrapper>
      <CheckboxField
        label="Display options alphabetically"
        name={getFieldNameWithPrefix('isOptionsAlphabetized', prefix)}
      />
    </ModalFieldWrapper>
  );
}
